import { Role as RoleEnum } from '../app/modules/user-management/interfaces/User.types';

export const Permission = {
  Customer: {
    Account: {
      UPDATE: 'mykb:customer:account:update',
    },
    Role: {
      UPDATE: 'mykb:customer:role:update',
    },
    User: {
      AUTHORIZE: 'am:customer:user:authorize',
      UNAUTHORIZE: 'am:customer:user:unauthorize',
      SEND_INVITATION: 'am:customer:user:send-invitation',
      DELETE: 'mykb:customer:user:delete',
      ADD_OPERATOR: 'am:customer:user:add-operator',
      EDIT_OPERATOR: 'am:customer:user:edit-operator',
      DELETE_OPERATOR: 'am:customer:user:delete-operator',
    },
  },
  Internal: {
    Role: {
      UPDATE: 'mykb:internal:role:update',
    },
  },
  Machine: {
    CLAIM: 'am:machine:claim',
    UPDATE: 'am:machine:update',
    ActivationStatus: {
      UPDATE: 'am:machine:activation-status:update',
    },
    Comment: {
      CREATE: 'am:machine:comment:create',
    },
    Reminder: {
      DELETE: 'am:machine:reminder:delete',
    },
  },
  Site: {
    CREATE: 'am:site:create',
    READ: 'am:site:read',
    UPDATE: 'am:site:update',
    DELETE: 'am:site:delete',
    Machine: {
      UPDATE: 'am:site:machine:update',
    },
    StrategicManager: {
      UPDATE: 'am:site:strategic-manager:update',
    },
    WorkInterval: {
      UPDATE: 'am:site:work-interval:update',
    },
  },
  Permissions: {
    READ: 'am:permissions:read',
  },
};

export const Role = {
  Customer: {
    ADMIN: RoleEnum.CustomerAdmin,
    STRATEGIC_MANAGER: RoleEnum.CustomerStrategicManager,
    OPERATOR: RoleEnum.CustomerOperator,
  },
};

export const Roles = [Role.Customer.ADMIN, Role.Customer.STRATEGIC_MANAGER, Role.Customer.OPERATOR];

export const PermissionsByRole = {
  [Role.Customer.ADMIN]: [
    // same as strategic/site manager
    Permission.Machine.ActivationStatus.UPDATE,
    Permission.Machine.UPDATE,
    Permission.Machine.Comment.CREATE,
    Permission.Machine.Reminder.DELETE,
    Permission.Site.UPDATE,
    Permission.Site.WorkInterval.UPDATE,
    Permission.Site.Machine.UPDATE,
    Permission.Site.READ,

    // differ from strategic/site manager
    Permission.Customer.Role.UPDATE,
    Permission.Customer.User.DELETE,
    Permission.Customer.User.UNAUTHORIZE,
    Permission.Customer.User.SEND_INVITATION,
    Permission.Site.CREATE,
    Permission.Site.DELETE,
    Permission.Site.StrategicManager.UPDATE,
    Permission.Permissions.READ,
    Permission.Customer.User.ADD_OPERATOR,
    Permission.Customer.User.EDIT_OPERATOR,
    Permission.Customer.User.DELETE_OPERATOR,
  ],
  [Role.Customer.STRATEGIC_MANAGER]: [
    Permission.Machine.ActivationStatus.UPDATE,
    Permission.Machine.UPDATE,
    Permission.Machine.Comment.CREATE,
    Permission.Machine.Reminder.DELETE,
    Permission.Site.UPDATE,
    Permission.Site.WorkInterval.UPDATE,
    Permission.Site.Machine.UPDATE,
    Permission.Site.READ,
  ],
  [Role.Customer.OPERATOR]: [Permission.Site.READ],
};

export const CognitoGroup = {
  ADMIN: Role.Customer.ADMIN,
  STRATEGIC_MANAGER: Role.Customer.STRATEGIC_MANAGER,
};
